<template>
	<eg-modal :show="show" @close="$emit('close', false)">
		<p class="center" slot="header"><b>Revisão de cotação</b></p>
		<div slot="body" class="row">
			<div class="input-field">
				<eg-textarea
					:has-icon="true"
					background-color="#FFF"
					icon="fas fa-user"
					v-model="message"
					placeholder-text="Deseja enviar as alterações realizadas?"
				/>
			</div>
		</div>
		<div slot="footer">
			<a
				@click="sendRevisionRequest"
				id="send-request"
				class="modal-action modal-close btn-flat"
				>Enviar</a
			>
		</div>
	</eg-modal>
</template>

<script>
import {sendRevisionRequest} from '@/services';
export default {
    name: 'RevisionMessage',
    data: () => ({
        message: '',
    }),
    props: {
        show: Boolean,
        competition_id: String,
        proposals: Array,
    },
    methods: {
        async sendRevisionRequest() {
            if (this.proposals.length) {
                const proposals = this.proposals.map(({id}) => id);
                const data = {
                    proposals,
                    message: this.message,
                    competition_id: this.competition_id,
                };
                await sendRevisionRequest(data);
            }
            this.$emit('close', false);
        },
    },
};
</script>

<style></style>
